import React from "react";
import FlipCard from "../FlipCard";

const Card = ({ detail }) => {
  return (
    <div className="flex max-md:flex-col w-full gap-y-4 sm:gap-y-6  max-lg:w-full">
      <div className="md:pr-3 w-full md:max-w-[276px] xl:w-6/12">
        <div className="flex flex-col h-full gap-y-6">
          <div className="flex grow w-full rounded-lg overflow-clip max-md:max-h-[284px]">
            <div className="relative w-full">
              <div className="w-full absolute top-0 left-0 h-full">
                <FlipCard imageUrl={detail.img}></FlipCard>
              </div>
              <img
                className="object-cover w-full object-center pointer-events-none opacity-0"
                src={detail.img}
                alt="card one"
              />
            </div>
          </div>
          <div className="flex grow w-full rounded-lg overflow-clip max-md:max-h-[284px]">
            <div className="relative w-full">
              <div className="w-full absolute top-0 left-0 h-full">
                <FlipCard imageUrl={detail.img2}></FlipCard>
              </div>
              <img
                className="object-cover w-full object-center pointer-events-none opacity-0"
                src={detail.img2}
                alt="card one"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex grow md:pl-3 xl:w-6/12">
        <div className="flex grow h-full w-full rounded-lg overflow-clip max-md:max-h-[406px]">
          <div className="relative w-full">
            <div className="w-full absolute top-0 left-0 h-full">
              <FlipCard imageUrl={detail.img3}></FlipCard>
            </div>
            <img
              className="object-cover w-full object-center pointer-events-none opacity-0"
              src={detail.img3}
              alt="card one"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
